export const traducciones = {
  es: {
    Title: "Contacto",
    formName: "Nombre",
    formEmail: "Correo electrónico",
    formSubject: "Asunto",
    formMessage: "Mensaje",
    formQuestion: "Pregunta de seguridad",
    formSubmit: "Enviar",
    errorRespuesta: "La respuesta es incorrecta.",
    mensajeExito: "Formulario enviado correctamente.",
    mensajeError: "Hubo un error al enviar el formulario. Inténtalo de nuevo."
  },
  en: {
    Title: "Contact",
    formName: "Name",
    formEmail: "Email",
    formSubject: "Subject",
    formMessage: "Message",
    formQuestion: "Security question",
    formSubmit: "Submit",
    errorRespuesta: "The answer is incorrect.",
    mensajeExito: "Form sent successfully.",
    mensajeError: "There was an error sending the form. Please try again."
  }
};
